module.exports = __webpack_public_path__ + "img/img40.8179bca6.svg";